var map = {
	"./banking/cards.svg": 2890,
	"./banking/currents.svg": 2891,
	"./banking/loans.svg": 2892,
	"./banking/mortgages.svg": 2893,
	"./banking/prepay-cards.svg": 2894,
	"./banking/savings.svg": 2895,
	"./energy/dualfuel.svg": 2896,
	"./energy/electricity.svg": 2897,
	"./energy/gas.svg": 2898,
	"./insurance/car-insurance.svg": 2899,
	"./insurance/health-insurance.svg": 2900,
	"./insurance/home-insurance.svg": 2901,
	"./insurance/life-insurance.svg": 2902,
	"./insurance/mortgage-protection.svg": 2903,
	"./insurance/serious-illness.svg": 2904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2889;